/** @jsxImportSource @emotion/react */
import React from "react";
import { StyledText } from "../assets/typography/typography";
import { colors } from "./colors";
import { SerializedStyles, css } from "@emotion/react";

interface DetailsRowProps extends React.HTMLAttributes<HTMLDivElement> {
  leftText: string | undefined | null;
  rightText?: string | undefined | null;
  leftTextFont?: string;
  rightTextFont?: string;
  leftTextColor?: string;
  rightTextColor?: string;
  icon?: React.ReactNode;
  additionalStyles?: SerializedStyles;
}

const wrapperStyle = css`
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: 8px;
  justify-content: space-between;
`;

const textStyle = css`
  margin-bottom: 0px;
`;

const leftTextStyle = css`
  white-space: nowrap;
`;

const containerStyle = css`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
`;

export const DetailsRow = ({
  leftText,
  rightText,
  className,
  leftTextFont,
  leftTextColor,
  rightTextColor,
  rightTextFont,
  icon,
  additionalStyles,
  ...rest
}: DetailsRowProps) => {
  return (
    <div css={[additionalStyles, wrapperStyle]} {...rest}>
      <div css={containerStyle}>
        <StyledText
          css={[textStyle, leftTextStyle]}
          color={leftTextColor || colors.textSecondary}
          className={`${leftTextFont || "bodyTextRegular"}`}
        >
          {leftText ? leftText : "-"}
        </StyledText>
      </div>

      <div css={containerStyle}>
        <StyledText
          css={textStyle}
          color={rightTextColor || colors.textPrimary}
          className={`${rightTextFont || "bodyTextRegular"}`}
        >
          {rightText ? rightText : "-"}
        </StyledText>
      </div>
    </div>
  );
};
